import "./styles/styles.css";
import Main from "./components/Main";
import { BiSearchAlt2, BiCameraMovie } from "react-icons/bi";
import {RiArrowUpCircleFill} from 'react-icons/ri'
import { useState, useEffect } from "react";



const API_KEY = "api_key="+ process.env.REACT_APP_API_KEY;
const MAIN_URL = "https://api.themoviedb.org/3";
const SEARCH = MAIN_URL + "/search/movie?" + API_KEY + "&page=1&query=";
const UPCOMING = MAIN_URL + "/movie/upcoming?" + API_KEY + "&language=en-US&page=1";
const POP_URL =MAIN_URL +"/movie/popular?" + API_KEY + "&language=en-US";
const NOW = MAIN_URL + '/movie/now_playing?' + API_KEY + '&language=en-US&page=1';
const TOP = MAIN_URL + "/movie/top_rated?" + API_KEY + "&language=en-US&page=1";



function App() {

  const [title, setTitle] = useState('Now Playing');
  const [search, setSearch] = useState();
  const [now, setNow] = useState([]);

  useEffect(() => {
    displayNow(NOW)
  
  }, []);

  const displayNow = (url) => {
    fetch(url)
      .then((res) => res.json())
      .then((data) => {
        setNow(data.results);
      });
  };
 
  
  
  //search button

  
  const handleSubmit = (e) => {
    e.preventDefault();
  
    fetch(SEARCH + search)
      .then((res) => res.json())
      .then((data) => {
        setNow(data.results);
      });
      if (search == "") {
        setTitle('input')
      }
    setTitle('Results for ' + `"${search}"`);
    setSearch('');

  
  };
 
  const handleSearch = (e) => {
    setSearch(e.target.value);

  
  };


  //upcoming button
  
  const handleUpcoming= (e) => {
    e.preventDefault();
    fetch(UPCOMING)
      .then((res) => res.json())
      .then((data) => {
        setNow(data.results);
      });
    setTitle('Upcoming Movies')
    setSearch('');
    
  };

 //popular button
  const handlePopular= (e) => {
    e.preventDefault();
    fetch(POP_URL)
      .then((res) => res.json())
      .then((data) => {
        setNow(data.results);
      });
    setTitle('Popular Movies')
    
  };

  //top button
  const handleTop= (e) => {
    e.preventDefault();
    fetch(TOP)
      .then((res) => res.json())
      .then((data) => {
        setNow(data.results);
      });
    setTitle('Top Rated Movies')
    setSearch('');
    
  };
 
  //now button
  const handleNow= (e) => {
    e.preventDefault();
    fetch(NOW)
      .then((res) => res.json())
      .then((data) => {
        setNow(data.results);
      });
    setTitle('Now Playing ')
    setSearch('');
    
    
  };
  

  return (


    <div className="App">
      <h2  className="logo" id='logo'>MovieHunt <BiCameraMovie /> </h2>
      <form onSubmit={handleSubmit}>
        <input
          type="text"
          placeholder="Search"
          value={search}
          onChange={handleSearch}

          
        />
        <button type= 'submit' >
          <BiSearchAlt2 style={{fontSize:18}} />
        </button>
      </form>

      <div className="btns">
      <div className="btn">
      <button onClick={handleUpcoming}>
        Upcoming
        </button>
      </div>

      <div className="btn">
      <button onClick={handlePopular}>
        Popular 
        </button>
      </div>

      
      <div className="btn">
      <button onClick={handleTop}>
        Top Rated
        </button>
      </div>

        
      <div className="btn">
       <button onClick={handleNow}>
        Now Playing
        </button>
      </div>
      </div>
      <div className="arrownav"><a href='#logo'><RiArrowUpCircleFill/></a></div>
     
      <h1 className='title'>{title}</h1>
      <div className="now">
       
      {now.map((movie) => (
         <Main key={movie.id} title={movie.title} img={movie.poster_path} ratings={movie.vote_average} overview={movie.overview} release={movie.release_date} />
      ))}
      </div>
      
      </div>
  );
}


export default App;


